import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../../lib/const/constants';
import { ToastContainer, toast } from 'react-toastify';
import { encryptPayload } from '../../utils/encryption';

const FasterPayemtPreviewScreen = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const previewData = state?.previewData || [];

  const [loading, setLoading] = useState(false);

  console.log('previewData', previewData);

  const handleConfirm = async () => {

    if (loading) return;

    setLoading(true);

    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const staff_login_id = sessionStorage.getItem('staff_login_id');

    try {

      for (let item of previewData) {

        const payload = {
          workspaceId: login_workspaces_id,
          account_number: item?.account_number,
          sort_code: item?.sort_code,
          beneficiary_name: item?.beneficiary_name,
          amount: parseFloat(item?.amount).toFixed(2),
          reference: item?.reference,
          reason: item?.reference,
          currency: "GBP",
          platform: "web",extraParamValidation: 'trustedfromweb'
        };
        const encPayload = await encryptPayload(payload)
        if (staff_login_id) {
          payload.staff_login_id = staff_login_id;
        }

        console.log(
          Constants.BASE_URL +
          "API-FX-248-CREATE-FASTER-PAYMENT"
        );

        console.log("payload", payload);

        console.log("workspace", login_workspaces_id);

        console.log("staff_login_id", staff_login_id);

        console.log(
          "token",
          sessionStorage.getItem("login_token")
        );

        const resp = await axios.post(
          Constants.BASE_URL +
          "API-FX-248-CREATE-FASTER-PAYMENT",
          encPayload,
          {
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('login_token')),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          }
        );

        console.log("response", resp);

        if (resp?.data?.status === false) {
          throw new Error("Transaction failed");
        }
      }

      toast.success("Transaction Successful");

      setTimeout(() => {
        navigate("/FasterPayment");
      }, 1500);

    }
    catch (err) {

      console.log("FULL ERROR", err);

      console.log("ERROR RESPONSE", err?.response);

      toast.error(
        err?.response?.data?.message ||
        err?.message ||
        "Transaction failed"
      );
    }
    finally {

      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">

      <ToastContainer />

      <div className="max-w-6xl mx-auto bg-white p-6 rounded-xl shadow">

        <h2 className="text-xl font-semibold mb-4">
          Preview Details
        </h2>

        <div className="overflow-x-auto">

          <table className="w-full border border-gray-200 rounded-lg overflow-hidden">

            <thead className="bg-gray-200 text-gray-700 text-sm">
              <tr>
                <th className="px-4 py-2 text-left">S.No</th>
                <th className="px-4 py-2 text-left">
                  Beneficiary Name
                </th>
                <th className="px-4 py-2 text-left">
                  Account Number
                </th>
                <th className="px-4 py-2 text-left">
                  Sort Code
                </th>
                <th className="px-4 py-2 text-left">
                  Reference
                </th>
                <th className="px-4 py-2 text-left">
                  Amount
                </th>
              </tr>
            </thead>

            <tbody className="text-sm text-gray-700">

              {previewData.length > 0 ? (

                previewData.map((item, index) => (

                  <tr
                    key={index}
                    className="border-t hover:bg-gray-50 transition"
                  >

                    <td className="px-4 py-2">
                      {index + 1}
                    </td>

                    <td className="px-4 py-2">
                      {item?.beneficiary_name}
                    </td>

                    <td className="px-4 py-2">
                      {item?.account_number}
                    </td>

                    <td className="px-4 py-2">
                        {item?.sort_code
    ?.replace(/\D/g, "")
    .replace(/(\d{2})(\d{2})(\d{2})/, "$1-$2-$3")}
                    </td>

                    <td className="px-4 py-2">
                      {item?.reference}
                    </td>

                    <td className="px-4 py-2 font-semibold text-green-600">
                      £ {item?.amount}
                    </td>

                  </tr>
                ))

              ) : (

                <tr>
                  <td
                    colSpan="6"
                    className="text-center py-4"
                  >
                    No data available
                  </td>
                </tr>
              )}

            </tbody>

          </table>

        </div>

        <div className="flex justify-between mt-6">

          <button
            onClick={() => navigate(-1)}
            disabled={loading}
            className={`px-4 py-2 rounded-lg text-white ${
              loading
                ? 'bg-gray-300 cursor-not-allowed'
                : 'bg-gray-500'
            }`}
          >
            Back
          </button>

          <button
            className={`px-4 py-2 rounded-lg text-white ${
              loading
                ? 'bg-green-300 cursor-not-allowed'
                : 'bg-green-500'
            }`}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Confirm'}
          </button>

        </div>

      </div>

    </div>
  );
};

export default FasterPayemtPreviewScreen;